/**
 * ThemeProvider — dark-mode only.
 *
 * Light mode was removed to eliminate the class of visibility bugs caused by
 * ambiguous `bg-white → dark:bg-black` global overrides. The site is now
 * dark-first, permanently. `useTheme()` remains for any component that still
 * imports it (returns theme='dark', a no-op toggleTheme), keeping the API
 * stable for the admin panel and any future consumers.
 */
import { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('dark');
    root.style.colorScheme = 'dark';
    // Clean up any stale localStorage from previous light-mode toggling
    try { window.localStorage.removeItem('therefore-theme'); } catch (err) { console.warn('[Theme] Failed to clean stale localStorage:', err); }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'dark', toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
